import Button from '@material-ui/core/Button';
import * as React from 'react';
import { Link } from 'react-router-dom';
import './home.css';

import Church from './church.jpg';
import Logo from './logo.png';

export class Home extends React.Component {
  public render() {
    return (
      <div className="home">
        <img src={Logo} className="logo" alt="Fun Fest Logo"/>
        <a href="https://supporter.greatergiving.com/Login?AT=8&PK=viYyYRVJ2n-kyYwo&ReturnUrl=https%3A%2F%2Fstcath2019.ggo.bid%2Fbidding%2Fpackage-browse" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Register for the Silent Action
          </Button>
        </a>
        <a href="https://stcath2019.ggo.bid/bidding/package-browse" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Silent Auction
          </Button>
        </a>
        <Link to="/volunteer">
          <Button variant="contained" color="primary">
            Volunteer
          </Button>
        </Link>
        <img src={Church} className="church" alt="St. Catherine Church"/>
        <h2>Saint Catharine Parish</h2>
        <h4>500 South Gould Road</h4>
        <h4>Columbus, Ohio 43209</h4>
        <h4>614-231-4509</h4>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/index.tsx